import Vue from 'vue'
import Router from 'vue-router'

import Info from './views/Info.vue'
import InfoSlider from './views/InfoSlider.vue'
import BurleMarx from './views/BurleMarx.vue'
import BurleMarxCreate from './views/BurleMarxCreate.vue'
import BurleMarxLive from './views/BurleMarxLive.vue'
import BurleMarxGrow from './views/BurleMarxGrow.vue'
import BurleMarxQuiz from './views/BurleMarxQuiz.vue'
import BurleMarxGame from './views/BurleMarxGame.vue'
import BurleMarxVirtualLandscape from './views/BurleMarxVirtualLandscape.vue'
import AllMedia from './views/AllMedia.vue'
import GardenMap from './views/GardenMap.vue'
import FlyoverMap from './views/FlyoverMap.vue'
import PlantfluencerList from './views/PlantfluencerList.vue'
import Plantfluencer from './views/Plantfluencer.vue'
import RecipeList from './views/RecipeList.vue'
import ExhibitList from './views/ExhibitList.vue'
import Recipe from './views/Recipe.vue'
import PlaylistPage from './views/PlaylistPage.vue'

/* eslint-disable */
import Background1 from './assets/backgrounds/1.jpg'
import Background2 from './assets/backgrounds/2.jpg'
import Background3 from './assets/backgrounds/3.jpg'
import Background4 from './assets/backgrounds/4.jpg'
import Background5 from './assets/backgrounds/5.jpg'
import Background6 from './assets/backgrounds/6.jpg'
import Background7 from './assets/backgrounds/7.jpg'
import Background8 from './assets/backgrounds/8.jpg'
import Background9 from './assets/backgrounds/9.jpg'
import Background10 from './assets/backgrounds/10.jpg'
/* eslint-disable */

Vue.use(Router)

function addBackLink(route, link) {
  return {
    ...route.params,
    backLink: link
  }
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [

    /**
     * Below here, global routes leading to all experiences
     */
    // {
    //   path: '/',
    //   name: 'home',
    //   component: Home
    // },

    // {
    //   path: '/choose',
    //   name: 'choose',
    //   component: Intro
    // },

    /**
     * Below here, routes for the Burle Marx experience
     */
    {
      path: '/',
      name: 'burle-marx-intro',
      component: Info,
      props: {
        // title: 'Roberto Burle Marx',
        page: 'main-intro',
        routeName: 'burle-marx',
        surroundImage: Background1,
        transparent: true,
        backLink: process.env.VUE_APP_EXPERIENCE_ROOT
      }
    },
    {
      path: '/entry',
      name: 'burle-marx',
      component: BurleMarx,
      props: {
        surroundImage: Background2,
        backLink: {
          name: 'burle-marx-intro'
        }
      }
    },
    // CREATE LIKE
    {
      path: '/create',
      name: 'burle-marx-create',
      component: BurleMarxCreate,
      props: {
        surroundImage: Background3,
        backLink: {
          name: 'burle-marx'
        }
      }
    },
    {
      path: '/create/see-from-above/intro',
      name: 'burle-marx-create-flyover-intro',
      component: Info,
      props: {
        page: 'see-from-above',
        routeName: 'burle-marx-create-flyover',
        surroundImage: Background5,
        title: 'See From Above',
        backLink: {
          name: 'burle-marx-create'
        }
      }
    },
    {
      path: '/create/see-from-above/exhibits',
      name: 'burle-marx-create-fly-over-exhibits',
      component: ExhibitList,
      props: {
        routeName: 'burle-marx-create-fly-over-exhibit',
        exhibitGroup: 'flyover-map',
        title: 'See From Above',
        backLink: {
          name: 'burle-marx-create-flyover-intro'
        }
      }
    },
    {
      path: '/create/see-from-above/exhibits/:exhibitslug',
      name: 'burle-marx-create-fly-over-exhibit',
      component: AllMedia,
      props: (route) => addBackLink(route, {
        name: 'burle-marx-create-flyover'
      })
    },
    {
      path: '/create/see-from-above',
      name: 'burle-marx-create-flyover',
      component: FlyoverMap,
      props: {
        exhibitGroup: 'flyover-map',
        title: 'See From Above',
        backLink: {
          name: 'burle-marx-create'
        }
      }
    },
    {
      path: '/create/virtual-landscape/intro',
      name: 'burle-marx-create-virtual-landscape-intro',
      component: Info,
      props: {
        page: 'virtual-landscape',
        routeName: 'burle-marx-create-virtual-landscape-intro-slider',
        surroundImage: Background4,
        title: 'Virtual Landscape',
        backLink: {
          name: 'burle-marx-create'
        }
      }
    },
    {
      path: '/create/virtual-landscape/intro-slider',
      name: 'burle-marx-create-virtual-landscape-intro-slider',
      component: InfoSlider,
      props: {
        routeName: 'burle-marx-create-virtual-landscape',
        surroundImage: Background4,
        title: 'Virtual Landscape',
        backLink: {
          name: 'burle-marx-create-virtual-landscape-intro'
        }
      }
    },
    {
      path: '/create/virtual-landscape',
      name: 'burle-marx-create-virtual-landscape',
      component: BurleMarxVirtualLandscape,
      props: {
        title: 'Virtual Landscape',
        backLink: {
          name: 'burle-marx-create-virtual-landscape-intro-slider'
        }
      }
    },
    // LIVE LIKE
    {
      path: '/grow',
      name: 'burle-marx-grow',
      component: BurleMarxGrow,
      props: {
        surroundImage: Background8,
        backLink: {
          name: 'burle-marx'
        }
      }
    },
    {
      path: '/grow/plant-personality',
      name: 'burle-marx-grow-plant-personality',
      component: BurleMarxQuiz,
      props: {
        src: process.env.BASE_URL + 'frames/quiz/',
        title: 'Plant Personality',
        surroundImage: Background6,
        backLink: {
          name: 'burle-marx-grow'
        }
      }
    },
    {
      path: '/grow/plant-personality/intro',
      name: 'burle-marx-grow-plant-personality-intro',
      component: Info,
      props: {
        page: 'plant-personality',
        routeName: 'burle-marx-grow-plant-personality',
        surroundImage: Background6,
        title: 'Plant Personality',
        backLink: {
          name: 'burle-marx-grow'
        }
      }
    },
    {
      path: '/grow/plantfluencers',
      name: 'burle-marx-grow-plantfluencers',
      component: PlantfluencerList,
      props: {
        title: 'Planted: Brazil',
        backLink: {
          name: 'burle-marx-grow-plantfluencers-intro'
        }
      }
    },
    {
      path: '/grow/plantfluencers/intro',
      name: 'burle-marx-grow-plantfluencers-intro',
      component: Info,
      props: {
        page: 'planted',
        routeName: 'burle-marx-grow-plantfluencers',
        surroundImage: Background9,
        title: 'Planted: Brazil',
        backLink: {
          name: 'burle-marx-grow'
        }
      }
    },
    {
      path: '/grow/plantfluencers/:plantfluencer',
      name: 'burle-marx-grow-plantfluencer',
      component: Plantfluencer,
      props(route) {
        return {
          plantfluencer: route.params.plantfluencer,
          surroundImage: Background9,
          title: 'Planted: Brazil',
          backLink: {
            name: 'burle-marx-grow-plantfluencers'
          }
        }
      }
    },
    // LIVE LIKE
    {
      path: '/live',
      name: 'burle-marx-live',
      component: BurleMarxLive,
      props: {
        surroundImage: Background10,
        backLink: {
          name: 'burle-marx'
        }
      }

    },
    {
      path: '/live/sitio',
      name: 'burle-marx-live-sitio',
      component: RecipeList,
      props: {
        title: 'A Taste of the Sítio',
        backLink: {
          name: 'burle-marx-live-sitio-intro'
        }
      }
    },
    {
      path: '/live/sitio/intro',
      name: 'burle-marx-live-sitio-intro',
      component: Info,
      props: {
        page: 'a-taste-of-the-sitio',
        routeName: 'burle-marx-live-sitio',
        surroundImage: Background9,
        title: 'A Taste of the Sítio',
        backLink: {
          name: 'burle-marx-live'
        }
      }
    },
    {
      path: '/live/sitio/:recipe',
      name: 'burle-marx-live-sitio-recipe',
      component: Recipe,
      props(route) {
        return {
          recipe: route.params.recipe,
          surroundImage: Background9,
          title: 'A Taste of the Sítio',
          backLink: {
            name: 'burle-marx-live-sitio'
          }
      }
      }
    },
    {
      path: '/live/playlist',
      name: 'burle-marx-live-playlist',
      component: PlaylistPage,
      props: {
        title: 'Brazilian Playlist',
        playlistKey: 'brazilian-playlist',
        surroundImage: Background7,
        backLink: {
          name: 'burle-marx-live-playlist-intro'
        }
      }
    },
    {
      path: '/play/playlist/intro',
      name: 'burle-marx-live-playlist-intro',
      component: Info,
      props: {
        page: 'brazilian-playlist',
        routeName: 'burle-marx-live-playlist',
        title: 'Brazilian Playlist',
        surroundImage: Background7,
        backLink: {
          name: 'burle-marx-live'
        }
      }
    },
    {
      path: '/live/collection-expedition',
      name: 'burle-marx-live-game',
      component: BurleMarxGame,
      props: {
        src: process.env.BASE_URL + 'frames/collection-expedition/',
        title: 'Collection Expedition',
        surroundImage: Background7,
        backLink: {
          name: 'burle-marx-live-game-intro'
        }
      },
      beforeEnter(to, from, next) {
        if (to.name == 'burle-marx-live-game') {
          Vue.gtm.trackEvent({
            category: 'Collection Expedition',
            action: 'Enter Game'
          })
          window.location.href = process.env.BASE_URL + 'frames/collection-expedition/'
          next(false)
        }
      }
    },
    {
      path: '/play/collection-expedition/intro',
      name: 'burle-marx-live-game-intro',
      component: Info,
      props: {
        page: 'collection-expedition',
        routeName: 'burle-marx-live-game',
        title: 'Collection Expedition',
        subtitle: 'Viagen de Coleta',
        surroundImage: Background8,
        backLink: {
          name: 'burle-marx-live'
        }
      }
    },

    {
      path: '/garden-map',
      name: 'burle-marx-garden-map',
      component: GardenMap,
      props: {
        exhibitGroup: 'garden-map',
        backLink: {
          name: 'burle-marx'
        }
      }
    },
    {
      path: '/credits',
      name: 'burle-marx-credits',
      component: Info,
      props: {
        page: 'credits',
        surroundImage: Background10,
        backLink: {
          name: 'burle-marx'
        }
      }
    },


    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    // }
  ]
})
// router.beforeEach((to, from, next) => {
//   console.log(to)
//   // if (to.name == 'burle-marx-live-game') {
//   //   window.location.href = process.env.BASE_URL + 'frames/collection-expedition/'
//   //   next(false)
//   // }
//   next()
// })
// console.log(Router)
export default router